<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';
  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: z-index('overlay');
    &-enter-active, &-leave-active {
      transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
    }
    &-enter, &-leave-to {
      z-index: 0;
    }
    &__card {
      background-color: color('white');
      width: 500px;
      position: relative;
      padding: space('luxury') space('cozy');
      z-index: z-index('overlay');
      &-enter-active, &-leave-active {
        transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
      }
      &-enter {
        opacity: 0;
        transform: translateY(-150%);
      }
      &-leave-to {
        opacity: 0;
        transform: translateY(150%);
      }
    }
    &__close {
      position: absolute;
      right: space('tight');
      top: space('tight');
      svg{
        @include svg-dim("base");
      }
    }
  }

  .dimmer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 799;
    background-color: rgba(color('black'), 0.6);
    cursor: pointer;
    &-enter-active, &-leave-active {
      transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
</style>
<template>
  <div>
    <transition name="overlay">
      <div class="overlay" v-show=overlay_popup_isOpen>
        <transition name="overlay__card">
          <div class="overlay__card" v-show=overlay_popup_isOpen>
            <v-button class="button-circle --grey overlay__close" @click.prevent="close">
              <svg>
                <use xlink:href="#close"></use>
              </svg>
            </v-button>
            <div v-if="overlay_popup_content == 'delete'">
              Willst du das sicher löschen?
              <div class="edit__footer">
                <v-button cssClass="button --secondary" @click.prevent="close">Cancel</v-button>
                <v-button @click.prevent="overlay_popup_cb">Delete</v-button>
              </div>
            </div>
          </div>
        </transition>
        <transition name="dimmer">
          <div class="dimmer" v-show=overlay_popup_isOpen :class="[cssClass]" @click="close"></div>
        </transition>
      </div>
    </transition>
  </div>
</template>
<script>
import Edit from '../components/album/edit';
import Create from '../components/album/create';
import Photo from '../components/album/photo';
import Uploader from '../components/album/uploader';
import Settings from '../components/album/settings';
import Button from './button';
import { mapGetters } from 'vuex';

export default {
  name: 'overlay',
  components: {
    'v-edit': Edit,
    'v-create': Create,
    'v-photo': Photo,
    'v-button': Button,
    'v-uploader': Uploader,
    'v-settings': Settings
  },
  data() {
    return {

    };
  },
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  },
  mounted() {

  },
  computed: {
    ...mapGetters([
      'overlay_popup_isOpen',
      'overlay_popup_content',
      'overlay_popup_cb',
      'activeId'
    ])
  },
  methods: {
    close() {
      this.$store.commit('overlay_popup_isOpen', false);
    }
  },
  watch: {
    // overlay_isOpen: function() {
    //   if (this.overlay_isOpen === false) {
    //     this.$store.commit('overlay_content', '');
    //   }
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OverlayPopup.vue